import { render, staticRenderFns } from "./OutboundOrderDetail.vue?vue&type=template&id=1d982e85&scoped=true&"
import script from "./OutboundOrderDetail.vue?vue&type=script&lang=js&"
export * from "./OutboundOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutboundOrderDetail.vue?vue&type=style&index=0&id=1d982e85&scoped=true&lang=less&"
import style1 from "./OutboundOrderDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d982e85",
  null
  
)

export default component.exports